import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Box,
  Image,
  Text,
  Flex,
  SimpleGrid,
  Icon,
  Grid,
  GridItem,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import {
  FaBitcoin,
  FaSearch,
  FaNewspaper,
  FaBasketballBall,
  FaDice,
  FaBox,
  FaAngleRight,
} from "react-icons/fa";
import SportsImage from "../assets/img/blog/sports-image.webp";
import CasinoImage from "../assets/img/blog/casino-image.webp";
import textBannerImage from "../assets/img/promotions/group-banner-default.png";
import Bonusmm1 from "../assets/img/promotions/nfl-bg-750x396.png";
import CryptoBonus1 from "../assets/img/promotions/Crypto-Bonus-1.png";
import ReferaFriend1 from "../assets/img/promotions/Refer-a-Friend-1.png";
import ReloadBonus1 from "../assets/img/promotions/Reload-Bonus-1.png";
import WelcomeBonus01 from "../assets/img/promotions/Welcome-Bonus01.png";
import StreakBonus from "../assets/img/promotions/StreakBonus.png";
import { useLinepros1 } from "../useLinepros1";
import { Global } from "@emotion/react";

const Promotions = () => {
  const { trackHeight } = useLinepros1();

  useEffect(() => {
    trackHeight();
  }, [trackHeight]);





  const bg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.800", "white");
  const endTimeColor = useColorModeValue("gray.800", "gray.400");

  const textColor1 = useColorModeValue("gray.800", "gray.500");
  const iconColor = useColorModeValue("gray.600", "gray.300");
  const tabBg = useColorModeValue("gray.100", "gray.700");
  const popupBg = "#e3f0ff"; // light blue
  const popupText = "#111";

  // Popup state
  const [openPromo, setOpenPromo] = useState(null);

  // Promotion data
  const promotions = [
    {
      key: "riskfree",
      image: Bonusmm1,
      alt: "Bonusmm1",
      title: "If a player’s first bet loses, they get it back as a free bet.",
      popupTitle: "$50 Risk-Free Bet!",
      popupContent: (
          <Box>
            <Text mb={2}><b>Place your first sports bet up to $50.</b></Text>
            <Text mb={2}>👉 If it wins – you keep the winnings.<br/>👉 If it loses – we’ll refund you up to $50 as a Free Bet!</Text>
            <Text mb={2}>⚡ Min odds -200 (1.50).<br/>⚡ First bet only.<br/>⚡ Free Bet expires in 7 days.</Text>
            <Text mb={2}><a href="#" style={{color:'#1976d2', textDecoration:'underline'}} target="_blank" rel="noopener noreferrer">Full Terms & Conditions</a></Text>
            <Text fontWeight="bold" mt={4}>1. Eligibility</Text>
            <Text fontSize="sm">Offer available to new customers who register and fund their Wager Street account.<br/>Only one risk-free bet per person, household, IP address, or device.<br/>Claim it by contacting live-support.</Text>
            <Text fontWeight="bold" mt={2}>2. Offer Details</Text>
            <Text fontSize="sm">Place your first sports bet up to $50.<br/>If your first bet loses, you will receive up to $50 back as a free bet.<br/>If your first bet wins, the promotion is complete, and no refund applies.</Text>
            <Text fontWeight="bold" mt={2}>3. Qualifying Conditions</Text>
            <Text fontSize="sm">Minimum odds: -200 (1.50 decimal) or higher.<br/>Eligible bet types: straight wagers, parlays, and live bets.<br/>Excluded bet types: system bets, teasers, hedging/arbitrage bets, or opposite sides of the same event.</Text>
            <Text fontWeight="bold" mt={2}>4. Refund / Free Bet Credit</Text>
            <Text fontSize="sm">Maximum refund: $50.<br/>Refund is credited within 24 hours of the qualifying losing bet.<br/>Credited as a free bet, stake is not returned — only winnings are paid out.</Text>
            <Text fontWeight="bold" mt={2}>5. Expiration</Text>
            <Text fontSize="sm">Free bet or bonus cash must be used within 7 days of being credited.<br/>Unused free bets will expire automatically.</Text>
            <Text fontWeight="bold" mt={2}>6. Withdrawals</Text>
            <Text fontSize="sm">Only winnings are withdrawable after settlement.</Text>
            <Text fontWeight="bold" mt={2}>7. General Conditions</Text>
            <Text fontSize="sm">Wager Street reserves the right to modify or terminate this promotion at any time.<br/>Any evidence of bonus abuse, multiple accounts, or fraudulent activity will result in forfeiture of the promotion and related winnings.<br/>Standard bonus Terms & Conditions apply in addition to these rules.</Text>
          </Box>
      ),
    },
    {
      key: "crypto",
      image: CryptoBonus1,
      alt: "CryptoBonus1",
      title: "100% up to $1,000 for deposits made in Bitcoin or USDT.",
      popupTitle: "100% Crypto Deposit Bonus!",
      popupContent: (
          <Box>
            <Text mb={2}><b>Double your first crypto deposit — up to $2500!</b></Text>
            <Text mb={2}>⚡ 10x rollover on sports bets<br/>⚡ Min deposit: $25</Text>
            <Text mb={2}><a href="#" style={{color:'#1976d2', textDecoration:'underline'}} target="_blank" rel="noopener noreferrer">View Full Terms & Conditions</a></Text>
            <Text fontWeight="bold" mt={4}>1. Eligibility</Text>
            <Text fontSize="sm">Offer available to new and existing customers depositing with cryptocurrency.<br/>One bonus per player, household, IP address, or device.<br/>Minimum qualifying deposit: $25 (crypto equivalent).</Text>
            <Text fontWeight="bold" mt={2}>2. Bonus Details</Text>
            <Text fontSize="sm">Receive a 100% match bonus on your first crypto deposit.<br/>Maximum bonus amount: $2500 (or crypto equivalent).<br/>Contact live support to be credited after a qualifying deposit.</Text>
            <Text fontWeight="bold" mt={2}>3. Wagering Requirements</Text>
            <Text fontSize="sm">Bonus plus deposit must be wagered 10x (sports) before withdrawal.<br/>Example: Deposit $100 + $100 bonus = $200 x 10 = $2,000 total action required.<br/>Only settled bets count toward rollover.<br/>Minimum odds: -110 (1.50 decimal) or higher.</Text>
            <Text fontWeight="bold" mt={2}>4. Restricted Bets</Text>
            <Text fontSize="sm">The following do not count toward rollover:<br/>Opposite bets on the same event.<br/>Hedging or arbitrage bets.<br/>Cashed-out bets.<br/>Casino, poker, or other non-sports games.</Text>
            <Text fontWeight="bold" mt={2}>5. Bonus Expiration</Text>
            <Text fontSize="sm">Bonus funds must be wagered within 30 days of activation.<br/>Unused bonus funds will be forfeited after expiration.</Text>
            <Text fontWeight="bold" mt={2}>6. Withdrawals</Text>
            <Text fontSize="sm">Withdrawal requests before meeting rollover will be canceled.<br/>After rollover is met, winnings are withdrawable.</Text>
            <Text fontWeight="bold" mt={2}>7. General Conditions</Text>
            <Text fontSize="sm">Wager Street reserves the right to modify, suspend, or cancel this promotion at any time.<br/>Any evidence of bonus abuse, collusion, or multiple accounts will result in forfeiture of bonus and winnings.<br/>Standard Bonus Terms & Conditions apply.</Text>
          </Box>
      ),
    },
    {
      key: "refer",
      image: ReferaFriend1,
      alt: "ReferaFriend1",
      title: "Get a $50 free bet for every friend who deposits $100 or more.",
      popupTitle: "Refer a Friend & Earn!",
      popupContent: (
          <Box>
            <Text mb={2}><b>Invite your friends to join and when they deposit $100+, you’ll both score a $50 Free Bet!</b></Text>
            <Text mb={2}>⚡ Easy. Fast. Unlimited referrals.</Text>
            <Text mb={2}><a href="#" style={{color:'#1976d2', textDecoration:'underline'}} target="_blank" rel="noopener noreferrer">View Full Terms & Conditions</a></Text>
            <Text fontWeight="bold" mt={4}>1. Eligibility</Text>
            <Text fontSize="sm">Available to all registered customers with verified accounts.<br/>Referrer (existing customer) and referee (new customer) must both be 18+ and reside in eligible jurisdictions.<br/>Only one referral per household, IP address, or device.<br/>Both accounts must have funded at least $100 in order to be eligible.</Text>
            <Text fontWeight="bold" mt={2}>2. How It Works</Text>
            <Text fontSize="sm">Share your unique referral link/code with friends.<br/>Contact support with your referee contact information.<br/>When your friend registers and makes a minimum deposit of $100 (or equivalent), both of you qualify.<br/>Referrer receives a $50 Free Bet.<br/>Referee (new customer) also receives a $50 Free Bet after meeting deposit requirement.</Text>
            <Text fontWeight="bold" mt={2}>3. Free Bet Conditions</Text>
            <Text fontSize="sm">Free Bet value: $50.<br/>Stake not returned — only winnings are paid out.<br/>Minimum odds: -110 or higher.<br/>Free Bet must be used within 7 days of being credited.</Text>
            <Text fontWeight="bold" mt={2}>4. Restrictions</Text>
            <Text fontSize="sm">Referral bonus only applies to sports betting (not casino, poker, or other products).<br/>Self-referrals, duplicate accounts, or fraudulent activity will result in disqualification.<br/>Referrals must be first-time customers; existing or previously registered accounts are ineligible.</Text>
            <Text fontWeight="bold" mt={2}>5. General Rules</Text>
            <Text fontSize="sm">Maximum number of referrals per customer: 10 referrals per month.<br/>Wager Street reserves the right to withhold or reclaim bonuses if abuse, fraud, or irregular play is suspected.<br/>Standard site Terms & Conditions apply in addition to these rules.</Text>
          </Box>
      ),
    },
    {
      key: "reload",
      image: ReloadBonus1,
      alt: "ReloadBonus1",
      title: "50% up to $250 on every deposit over $100.",
      popupTitle: "50% Reload Bonus!",
      popupContent: (
          <Box>
            <Text mb={2}><b>Top up your account and get 50% extra — up to $2500!</b></Text>
            <Text mb={2}>⚡ Min deposit: $25<br/>⚡ 5x rollover on sports bets<br/>⚡ 30 days to use</Text>
            <Text mb={2}><a href="#" style={{color:'#1976d2', textDecoration:'underline'}} target="_blank" rel="noopener noreferrer">View Full Terms & Conditions</a></Text>
            <Text fontWeight="bold" mt={4}>1. Eligibility</Text>
            <Text fontSize="sm">Available to existing customers with an active, verified account.<br/>One bonus per player, household, IP address, or device per reload period.<br/>Minimum qualifying deposit: $25.</Text>
            <Text fontWeight="bold" mt={2}>2. Bonus Details</Text>
            <Text fontSize="sm">Receive a 50% bonus on qualifying reload deposits.<br/>Maximum bonus amount: $2500 per reload (or equivalent).<br/>Contact live support to apply your bonus.</Text>
            <Text fontWeight="bold" mt={2}>3. Wagering Requirements</Text>
            <Text fontSize="sm">Deposit + Bonus must be wagered 5x (sports) before withdrawal.<br/>Example: Deposit $100 + $50 bonus = $150 x 5 = $750 total action required.<br/>Minimum odds: -110 or higher.<br/>Only settled bets count toward rollover.</Text>
            <Text fontWeight="bold" mt={2}>4. Restrictions</Text>
            <Text fontSize="sm">Bonus valid for sports betting only.<br/>The following do not count toward rollover:<br/>Opposite bets on the same event.<br/>Hedging or arbitrage wagers.<br/>Cashed-out bets.<br/>Non-sports wagers (casino, poker, etc.).</Text>
            <Text fontWeight="bold" mt={2}>5. Bonus Expiration</Text>
            <Text fontSize="sm">Bonus funds must be wagered within 30 days of activation.<br/>Unused bonus funds will be forfeited after expiration.</Text>
            <Text fontWeight="bold" mt={2}>6. Withdrawals</Text>
            <Text fontSize="sm">Withdrawal requests before meeting rollover will be canceled.<br/>After rollover is met, winnings are withdrawable.</Text>
            <Text fontWeight="bold" mt={2}>7. General Rules</Text>
            <Text fontSize="sm">Wager Street reserves the right to modify, suspend, or cancel this promotion at any time.<br/>Any evidence of abuse, collusion, or multiple accounts will result in forfeiture of bonus and winnings.<br/>Standard site Terms & Conditions apply.</Text>
          </Box>
      ),
    },
    {
      key: "welcome",
      image: WelcomeBonus01,
      alt: "WelcomeBonus01",
      title: "100% up to $500 (new players only).",
      popupTitle: "100% Welcome Bonus!",
      popupContent: (
          <Box>
            <Text mb={2}><b>Boost your initial deposit — get up to $5000 extra!</b></Text>
            <Text mb={2}>⚡ Min deposit: $25<br/>⚡ 10x rollover on sports bets<br/>⚡ 30 days to use</Text>
            <Text mb={2}><a href="#" style={{color:'#1976d2', textDecoration:'underline'}} target="_blank" rel="noopener noreferrer">View Full Terms & Conditions</a></Text>
            <Text fontWeight="bold" mt={4}>1. Eligibility</Text>
            <Text fontSize="sm">Available to existing customers with a verified sportsbook account.<br/>One bonus per customer, household, IP address, or device per reload promotion.<br/>Minimum qualifying deposit: $25.</Text>
            <Text fontWeight="bold" mt={2}>2. Bonus Details</Text>
            <Text fontSize="sm">Get a 100% bonus on your first deposit (Any method).<br/>Maximum bonus: $1000 per reload (or equivalent).<br/>Contact Live support to get credited after a successful deposit.</Text>
            <Text fontWeight="bold" mt={2}>3. Wagering Requirements</Text>
            <Text fontSize="sm">Deposit + Bonus must be wagered 10x (sports) before withdrawal.<br/>Example: Deposit $100 + $100 bonus = $200 x 8 = $2000 total action required.<br/>Minimum odds: -110 or higher.<br/>Only settled wagers count toward rollover.</Text>
            <Text fontWeight="bold" mt={2}>4. Restrictions</Text>
            <Text fontSize="sm">Bonus valid for sports betting only.<br/>The following do not count toward rollover:<br/>Opposite bets on the same event.<br/>Arbitrage or hedge betting.<br/>Cashed-out wagers.<br/>Casino, poker, or other non-sports wagers.</Text>
            <Text fontWeight="bold" mt={2}>5. Bonus Expiration</Text>
            <Text fontSize="sm">Bonus funds must be fully wagered within 30 days of activation.<br/>Any unused bonus or winnings will be forfeited after expiration.</Text>
            <Text fontWeight="bold" mt={2}>6. Withdrawals</Text>
            <Text fontSize="sm">Withdrawal requests before completing rollover will void bonus and related winnings.<br/>Once rollover is met, deposit and bonus winnings are withdrawable.</Text>
            <Text fontWeight="bold" mt={2}>7. General Rules</Text>
            <Text fontSize="sm">WagerStreet reserves the right to amend, suspend, or terminate this promotion at any time.<br/>Abuse, multiple accounts, or fraudulent play will result in disqualification.<br/>Standard site Terms & Conditions apply.</Text>
          </Box>
      ),
    },
    {
      key: "streak",
      image: StreakBonus,
      alt: "StreakBonus",
      title: "Win 5 straight bets of $50+ and get a $100 free bet.",
      popupTitle: "Streak Bonus – Terms & Conditions",
      popupContent: (
          <Box>
            <Text mb={2}><b>Score rewards for consecutive wins:</b></Text>
            <Text mb={2}>⚡ 3 wins = $10 Free Bet<br/>⚡ 5 wins = $25 Free Bet<br/>⚡ 7 wins = $50 Free Bet<br/>⚡ 10 wins = $100 Free Bet<br/>Keep winning, keep earning!</Text>
            <Text mb={2}><a href="#" style={{color:'#1976d2', textDecoration:'underline'}} target="_blank" rel="noopener noreferrer">View Full Terms & Conditions</a></Text>
            <Text fontWeight="bold" mt={4}>1. Eligibility</Text>
            <Text fontSize="sm">Available to all active, verified sportsbook customers.<br/>One active streak per player, household, IP address, or device.<br/>Bets must be placed with real money or eligible bonus funds.</Text>
            <Text fontWeight="bold" mt={2}>2. Bonus Details</Text>
            <Text fontSize="sm">Win consecutive sports bets to earn streak rewards.<br/>Example payout structure:<br/>3 wins in a row = $10 Free Bet<br/>5 wins in a row = $25 Free Bet<br/>7 wins in a row = $50 Free Bet<br/>10 wins in a row = $100 Free Bet<br/>Bonuses must be claimed within 24 hours of achieving a qualifying streak by contacting Live Support team.</Text>
            <Text fontWeight="bold" mt={2}>3. Wagering Requirements</Text>
            <Text fontSize="sm">Free Bet winnings must be wagered 3x on sports before withdrawal.<br/>Minimum odds: -150 or higher.<br/>Only settled winning wagers count toward streak progression.</Text>
            <Text fontWeight="bold" mt={2}>4. Streak Rules</Text>
            <Text fontSize="sm">If a bet loses, the streak resets to zero.<br/>Cashed-out bets, void bets, and push results do not count toward streak progression.<br/>Parlays count as one wager toward streaks.<br/>Multiple streak bonuses may be won, but only one active streak per account at a time.</Text>
            <Text fontWeight="bold" mt={2}>5. Restrictions</Text>
            <Text fontSize="sm">Only sports wagers qualify.<br/>Opposite bets, arbitrage, or hedge betting will void the streak.<br/>Casino, poker, and other games do not qualify.</Text>
            <Text fontWeight="bold" mt={2}>6. Bonus Expiration</Text>
            <Text fontSize="sm">Free Bets awarded via streaks expire 7 days after issue.<br/>Unused Free Bets are forfeited after expiration.</Text>
            <Text fontWeight="bold" mt={2}>7. Withdrawals</Text>
            <Text fontSize="sm">Withdrawal requests before rollover completion will be canceled.<br/>Once rollover is met, Free Bet winnings are withdrawable.</Text>
            <Text fontWeight="bold" mt={2}>8. General Rules</Text>
            <Text fontSize="sm">Wager Street reserves the right to amend, suspend, or terminate this promotion at any time.<br/>Abuse, collusion, or use of multiple accounts will result in forfeiture.<br/>Standard sportsbook Terms & Conditions apply.</Text>
          </Box>
      ),
    },
  ];
  // const inputBg = useColorModeValue("gray.200", "gray.700");

  return (
      <>
        <Global
            styles=
                {`
              html, body {
                height: 100%;
                margin: 0;
                padding: 0;
                overflow-y: hidden;
              }
            `}
        />

        <Flex
            flexDirection="column"
            pt={{ base: "120px", md: "65px" }}
            px={{ base: 4, md: 8 }}
            bg={bg}
            color={textColor}
            height="100vh"
        >
          <Box padding="4" bg={bg}>
            {/* Header */}
            <Flex
                justify="space-between"
                align="center"
                mb="6"
                height={{base:115,sm:20}}
                backgroundColor={tabBg}
                p={4}
            >
              {/* Text on the left */}
              <Text fontSize={{ base: 'xl',sm:"md", md: '2xl', lg: '3xl' }} fontWeight="bold" color={textColor}>
                Promotions
              </Text>

              {/* Text Banner Image */}
              <Image
                  src={textBannerImage}
                  alt="Banner"
                  maxWidth={{ base: "45%", sm: "60%", md: "45%",lg:"25%" }}
                  height="auto"
              />
            </Flex>

            {/*<SimpleGrid columns={{ base: 1, sm: 1, md: 2 }} spacing="4" mb={6}>*/}
            {/*  /!* Casino Category *!/*/}
            {/*  <NavLink to="/promotions/casino">*/}
            {/*    <Flex*/}
            {/*      alignItems="center"*/}
            {/*      backgroundColor={tabBg}*/}
            {/*      borderRadius="md"*/}
            {/*      cursor="pointer"*/}
            {/*    >*/}
            {/*      <Image*/}
            {/*        src={CasinoImage}*/}
            {/*        alt="2024 MLB Predictions & World Series Picks"*/}
            {/*        borderRadius="md"*/}
            {/*        width={20}*/}
            {/*        height={20}*/}
            {/*        transition="all 0.2s ease-in-out"*/}
            {/*        _hover={{ transform: "translateY(-10px)" }}*/}
            {/*      />*/}
            {/*      <Text color={textColor} fontWeight="bold" pl={4} fontSize={"xl"}>*/}
            {/*        Casino*/}
            {/*      </Text>*/}
            {/*      <Box ml="auto">*/}
            {/*        <Icon as={FaAngleRight} w={8} h={8} color={textColor1} />*/}
            {/*      </Box>*/}
            {/*    </Flex>*/}
            {/*  </NavLink>*/}

            {/*  /!* Sport Category *!/*/}
            {/*  <NavLink to="/promotions/sports">*/}
            {/*    <Flex*/}
            {/*      alignItems="center"*/}
            {/*      backgroundColor={tabBg}*/}
            {/*      borderRadius="md"*/}
            {/*      cursor="pointer"*/}
            {/*    >*/}
            {/*      <Image*/}
            {/*        src={SportsImage}*/}
            {/*        alt="2024 MLB Predictions & World Series Picks"*/}
            {/*        borderRadius="md"*/}
            {/*        width={20}*/}
            {/*        height={20}*/}
            {/*        transition="all 0.2s ease-in-out"*/}
            {/*        _hover={{ transform: "translateY(-10px)" }}*/}
            {/*      />*/}
            {/*      <Text color={textColor} fontWeight="bold" pl={4} fontSize={"xl"}>*/}
            {/*        Sports*/}
            {/*      </Text>*/}
            {/*      <Box ml="auto">*/}
            {/*        <Icon as={FaAngleRight} w={8} h={8} color={textColor1} />*/}
            {/*      </Box>*/}
            {/*    </Flex>*/}
            {/*  </NavLink>*/}
            {/*</SimpleGrid>*/}

            <Text fontSize="2xl" color={textColor} mb="6">
              Latest Promotions
            </Text>
            {/* Blog Posts Section */}
            {/* Responsive: Carousel on mobile, grid on desktop */}
            <Box display={{ base: "block", md: "none" }}>
              <Slider
                  dots={true}
                  infinite={true}
                  speed={500}
                  slidesToShow={1}
                  slidesToScroll={1}
                  arrows={false}
              >
                {promotions.map((promo) => (
                    <Box
                        key={promo.key}
                        backgroundColor={bg}
                        borderRadius="md"
                        p="4"
                        cursor="pointer"
                        _hover={{ boxShadow: "lg" }}
                        onClick={() => setOpenPromo(promo.key)}
                        transition="box-shadow 0.2s"
                        mx={2}
                    >
                      <Image
                          src={promo.image}
                          alt={promo.alt}
                          borderRadius="md"
                          mb="4"
                          transition="all 0.2s ease-in-out"
                          _hover={{ transform: "translateY(-10px)" }}
                      />
                      <Text color={textColor} fontWeight="bold" fontSize="lg" mb="2">
                        {promo.title}
                      </Text>
                    </Box>
                ))}
              </Slider>
            </Box>
            <Box display={{ base: "none", md: "block" }}>
              <SimpleGrid columns={{ md: 2, lg: 3 }} spacing="6">
                {promotions.map((promo) => (
                    <Box
                        key={promo.key}
                        backgroundColor={bg}
                        borderRadius="md"
                        p="4"
                        cursor="pointer"
                        _hover={{ boxShadow: "lg" }}
                        onClick={() => setOpenPromo(promo.key)}
                        transition="box-shadow 0.2s"
                    >
                      <Image
                          src={promo.image}
                          alt={promo.alt}
                          borderRadius="md"
                          mb="4"
                          transition="all 0.2s ease-in-out"
                          _hover={{ transform: "translateY(-10px)" }}
                      />
                      <Text color={textColor} fontWeight="bold" fontSize="lg" mb="2">
                        {promo.title}
                      </Text>
                    </Box>
                ))}
              </SimpleGrid>
            </Box>

            {/* Single Popup for the selected promotion */}
            {openPromo && (() => {
              const promo = promotions.find(p => p.key === openPromo);
              if (!promo) return null;
              return (
                  <Modal
                      isOpen={!!openPromo}
                      onClose={() => setOpenPromo(null)}
                      isCentered
                      size={{ base: "xs", sm: "md", md: "lg", lg: "xl" }}
                      motionPreset="slideInBottom"
                  >
                    <ModalOverlay />
                    <ModalContent bg={popupBg} color={popupText} borderRadius="lg" maxW="95vw">
                      <ModalHeader fontWeight="bold" fontSize={{ base: "lg", md: "2xl" }} textAlign="center">
                        {promo.popupTitle}
                      </ModalHeader>
                      <ModalCloseButton color={popupText} />
                      <ModalBody pb={6} fontSize={{ base: "sm", md: "md" }}>
                        {promo.popupContent}
                      </ModalBody>
                    </ModalContent>
                  </Modal>
              );
            })()}
          </Box>
        </Flex>
      </>
  );
};

export default Promotions;
